import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'wristband'
})
export class WristbandPipe implements PipeTransform {

  transform(value: any, args?: any): any {
    if(!value) {
      return "No Wristband Entered";
    }
    return `
      ${(value.identifierNumber) || "N/A"}
    `;
  }

}
